// Check if environment is development
const isDev = process.env.NODE_ENV === "development";

let API_ROOT = "";

if (isDev) {
  API_ROOT = "http://localhost:12000";
}

export { API_ROOT };